import { useFormContext } from 'react-hook-form'

import { ExpensesEntitiesExpensableResourceTypeEnum } from 'generated/resources/graphql'

import { ProjectWorker } from 'modules/expenses/hooks/useProjects'

import { CustomizationProps } from 'modules/expenses/components/expenses/Detail/_newForm/withCustomizationFields'
import { PermissionsProps } from 'modules/expenses/components/expenses/Detail/_newForm/withFieldPermissions'
import ProjectField from './ProjectField'
import { shouldShowBlock } from './form/schema'

interface Props extends PermissionsProps, CustomizationProps {
  projectWorkers: ProjectWorker[]
  hasProjectsFeature: boolean
  loading: boolean
  resourceType: ExpensesEntitiesExpensableResourceTypeEnum
}

const Projects = (props: Props) => {
  const {
    formState: { dirtyFields },
    getValues,
  } = useFormContext()

  const showProjectsBlock = shouldShowBlock(
    props.hasProjectsFeature,
    props.projectWorkers,
    props.customizationFields,
    props.resourceType
  )

  if (!showProjectsBlock) return null

  return (
    <ProjectField
      {...props}
      fieldIdentifier="projects"
      defaultValue={getValues('projects')[0]}
      dirtyEmployee={!!dirtyFields.employee}
    />
  )
}

export default Projects
